// Globals `amazon-cognito-identity-js` expects in a browser bundle. Same
// two shims the sibling portal installs
// (apps/classification-ui/src/components/auth/polyfills.jsx); both clients
// run the same SDK, so both need the same globals.
if (typeof window !== 'undefined') {
  const scope = window as unknown as Record<string, unknown>;
  if (scope.global === undefined) {
    scope.global = window;
  }
  if (scope.process === undefined) {
    scope.process = { env: {} };
  }
}

export {};
